<!-- <p>link-asset-datapoints works!</p> -->
<app-dialog-header headerIcon="link" headerText="Link DataPoints to Asset"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div class="content">
        <div class="top-div">
            <span class="title">
                Select Assets to Link
            </span>
            <div class="checkbox">
                <span>Select All</span>
                <mat-checkbox color="primary"></mat-checkbox>
            </div>
        </div>
        <div class="asset-listbox">
            <mat-form-field>
                <mat-label>Search for an Asset</mat-label>
                <input matInput (keyup)="onFilteringAssets($event)" placeholder="" #input>
            </mat-form-field>
            <div class="listbox-wrapper-asset">
                <ejs-listview [dataSource]='filteredAssets' [fields]="assetFields">
                    <ng-template #template let-data>
                        <div class="ejs-listview-item asset-item">
                            <span>{{ data.Name }} - {{ data.Description }}</span>
                            <span class="toolbar-spacer"></span>
                            <mat-checkbox color="primary" (change)="assetCheckboxChange($event, data)"></mat-checkbox>
                        </div>
                    </ng-template>
                </ejs-listview>
            </div>
        </div>
        <div class="top-div">
            <span class="title">
                Select DataPoints to Link
            </span>
            <div class="checkbox">
                <span>Select All</span>
                <mat-checkbox color="primary"></mat-checkbox>
            </div>
        </div>
        <div class="datapoint-listbox">
            <div class="listbox-wrapper">
                <ejs-listview [dataSource]='datapoints' [fields]="datapointFields" class="listbox-container">
                    <ng-template #template let-data>
                        <div class="ejs-listview-item">
                            <span>{{ data.DPTitle }}</span>
                            <span class="toolbar-spacer"></span>
                            <mat-checkbox color="primary"
                                (change)="datapointCheckboxChange($event, data)"></mat-checkbox>
                        </div>
                    </ng-template>
                </ejs-listview>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="OKButtonClick()"
            [disabled]="selectedAssets.length == 0 || selectedDatapoints.length == 0">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</div>